export default {
    "status": "ok",
    "totalResults": 10,
    "articles": [
        {
            "source": {
                "id": "bbc-news",
                "name": "BBC News"
            },
            "author": "BBC News",
            "title": "Philips pays $1.1bn to settle respirator case",
            "description": "The lower-than-expected settlement could help draw a line under a controversial episode for the company.",
            "url": "https://www.bbc.co.uk/news/articles/cn3dv3273dlo",
            "urlToImage": "https://ichef.bbci.co.uk/news/1024/branded_news/07b4/live/7fa5fe00-062b-11ef-b365-6f5a913deacf.jpg",
            "publishedAt": "2024-04-29T15:07:19.2240932Z",
            "content": "The machines were made by the company's US subsidiary Philips Respironics. Users reportedly complained of black particles and dust appearing inside their masks.\r\nMore than five million machines were … [+1813 chars]"
        },
        {
            "source": {
                "id": "bbc-news",
                "name": "BBC News"
            },
            "author": "BBC News",
            "title": "Tobago shark attack: Peter Smith now 'able to communicate'",
            "description": "Peter Smith's wife has thanked friends who fought the shark during the attack on Tobago's coast.",
            "url": "https://www.bbc.co.uk/news/uk-68918033",
            "urlToImage": "https://ichef.bbci.co.uk/news/1024/branded_news/10A26/production/_133243186_tobago-index-getty.jpg",
            "publishedAt": "2024-04-29T14:52:19.0990127Z",
            "content": "A British man seriously injured in a shark attack in Tobago is \"aware of what is happening\" and \"able to communicate\", his wife has said.\r\nPeter Smith, 64, was on the Caribbean island with wife Jo an… [+2833 chars]"
        },
        {
            "source": {
                "id": "bbc-news",
                "name": "BBC News"
            },
            "author": "BBC News",
            "title": "Gaza war: US 'hopeful' Hamas will accept Israel's new ceasefire offer",
            "description": "The secretary of state calls Israel's latest offer for a hostage release \"extraordinarily generous\".",
            "url": "https://www.bbc.co.uk/news/world-middle-east-68920131",
            "urlToImage": "https://ichef.bbci.co.uk/news/1024/branded_news/12E2A/production/_133245377_mediaitem133245089.jpg",
            "publishedAt": "2024-04-29T14:22:10.9425079Z",
            "content": "US Secretary of State Antony Blinken has said he is \"hopeful\" Hamas will accept Israel's latest proposal for a Gaza truce and hostage release deal.\r\nHe called the offer \"extraordinarily generous\", as… [+5319 chars]"
        },
        {
            "source": {
                "id": "bbc-news",
                "name": "BBC News"
            },
            "author": "BBC News",
            "title": "French actor Gérard Depardieu in custody over sexual assault allegations",
            "description": "French actor Gérard Depardieu is summoned to a police station in Paris, local media report.",
            "url": "https://www.bbc.co.uk/news/world-europe-68920563",
            "urlToImage": "https://ichef.bbci.co.uk/news/1024/branded_news/417C/production/_132746761_gettyimages-1246188797.jpg",
            "publishedAt": "2024-04-29T12:37:17.7873229Z",
            "content": "French actor Gérard Depardieu is in custody over allegations of sexual assault, according to media reports.\r\nThe 75-year-old actor was summoned to a Paris police station for questioning on Monday mor… [+1293 chars]"
        },
        {
            "source": {
                "id": "bbc-news",
                "name": "BBC News"
            },
            "author": "BBC News",
            "title": "Kenya dam bursts: More than 40 killed in Kamuchiri village",
            "description": "Heavy rain and flooding has caused a dam to burst, with fears that the death toll could rise.",
            "url": "https://www.bbc.co.uk/news/world-africa-68896456",
            "urlToImage": "https://ichef.bbci.co.uk/news/1024/branded_news/D4FC/production/_133242545_kenha.jpg",
            "publishedAt": "2024-04-29T11:22:22.6143248Z",
            "content": "More than 40 people have died in Kenya after a dam burst following heavy rains and flooding, officials have said. \r\nHomes were swept away and roads were cut off after the dam burst in Kamuchiri villa… [+1279 chars]"
        },
        {
            "source": {
                "id": "bbc-news",
                "name": "BBC News"
            },
            "author": "BBC News",
            "title": "'Invisible in our own country': Being Muslim in Modi's India",
            "description": "Since Narendra Modi's BJP took power in 2014, India's 200 million Muslims have faced turmoil.",
            "url": "https://www.bbc.co.uk/news/world-asia-india-68498675",
            "urlToImage": "https://ichef.bbci.co.uk/news/1024/branded_news/10D53/production/_133174986_7714d781-cd28-4bac-9ee1-a220bc98c75f.jpg",
            "publishedAt": "2024-04-29T11:22:19.8650086Z",
            "content": "Rahmani30 now mentors 850 students - girls and boys - in three cities, including Patna, Bihar's capital. Chosen students live in the school's rented buildings and cram for national entrance exams in … [+169 chars]"
        },
        {
            "source": {
                "id": "bbc-news",
                "name": "BBC News"
            },
            "author": "BBC News",
            "title": "US campus protests: Rival Gaza protest groups clash at UCLA",
            "description": "Scuffles break out between pro-Palestinian and pro-Israel activists, with no sign of student demos tailing off.",
            "url": "https://www.bbc.co.uk/news/world-us-canada-68919182",
            "urlToImage": "https://ichef.bbci.co.uk/news/1024/branded_news/10AEE/production/_133243386_gettyimages-2150099905.jpg",
            "publishedAt": "2024-04-29T11:07:19.7860026Z",
            "content": "Pro-Palestinian and pro-Israel protesters have clashed at the University of California, Los Angeles (UCLA) as demonstrations over the war in Gaza continue across US campuses.\r\nNationwide rallies - du… [+3772 chars]"
        },
        {
            "source": {
                "id": "bbc-news",
                "name": "BBC News"
            },
            "author": "BBC News",
            "title": "Spain's Prime Minister Pedro Sánchez will not resign after allegations against wife",
            "description": "Last week, Pedro Sánchez denounced what he called a \"harassment campaign\" against his wife.",
            "url": "https://www.bbc.co.uk/news/world-europe-68919354",
            "urlToImage": "https://ichef.bbci.co.uk/news/1024/branded_news/15846/production/_133243188_spain-index-reuters.jpg",
            "publishedAt": "2024-04-29T09:37:17.0521006Z",
            "content": "Spanish Prime Minister Pedro Sánchez has said he will stay on as Spain's leader, following five days of speculation over his future.\r\nLast week, Mr Sánchez announced he was cancelling all official en… [+860 chars]"
        },
        {
            "source": {
                "id": "bbc-news",
                "name": "BBC News"
            },
            "author": "BBC News",
            "title": "Roman object that baffled experts to go on show at Lincoln Museum",
            "description": "The 12-sided object, found in Norton Disney, is being shown as part of the Lincoln Festival of History.",
            "url": "https://www.bbc.co.uk/news/uk-england-lincolnshire-68908558",
            "urlToImage": "https://ichef.bbci.co.uk/news/1024/branded_news/5C01/production/_133235532_mediaitem133235530.jpg",
            "publishedAt": "2024-04-29T08:22:19.8293381Z",
            "content": "A mysterious Roman artefact found during an amateur archaeological dig is going on public display in Lincolnshire for the first time.\r\nThe object is one of only 33 dodecahedrons ever found in Britain… [+2481 chars]"
        },
        {
            "source": {
                "id": "bbc-news",
                "name": "BBC News"
            },
            "author": "BBC News",
            "title": "Stowaway cat accidently mailed to California in returned package",
            "description": "Galeana is back home in the US state of Utah and in good health after spending six days in a box.",
            "url": "https://www.bbc.co.uk/news/world-us-canada-68918102",
            "urlToImage": "https://ichef.bbci.co.uk/news/1024/branded_news/6EA4/production/_133242382_galeanablurredsides.jpg",
            "publishedAt": "2024-04-29T00:52:12.4703048Z",
            "content": "A family in the US has been reunited with their pet cat after she was accidentally mailed hundreds of miles to California with a package return.\r\nGaleana disappeared from her home in Utah earlier thi… [+1526 chars]"
        }
    ]
}